var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "max-w-6xl mx-auto my-10" }, [
    _c("h2", { staticClass: "text-xl text-gray-700 py-4" }, [
      _vm._v("Whatsapp API Approval")
    ]),
    _c("nav", { attrs: { "aria-label": "Progress" } }, [
      _c(
        "ol",
        {
          staticClass: "space-y-4 md:flex md:space-y-0 md:space-x-8",
          attrs: { role: "list" }
        },
        _vm._l(_vm.steps, function(step, index) {
          return _c("li", { key: index, staticClass: "md:flex-1" }, [
            _c(
              "a",
              {
                staticClass:
                  "group pl-4 py-2 flex flex-col border-l-4  md:pl-0 md:pt-4 md:pb-0 md:border-l-0 md:border-t-4",
                class: {
                  "border-indigo-600 hover:border-indigo-800":
                    step.isCompleted || _vm.currentStep.step === step.step,
                  "border-gray-200 hover:border-gray-300": !step.isCompleted
                },
                on: {
                  click: function($event) {
                    return _vm.gotoStep(step)
                  }
                }
              },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "text-xs  font-semibold tracking-wide uppercase ",
                    class: {
                      "text-indigo-600 group-hover:text-indigo-800":
                        step.isCompleted || _vm.currentStep.step === step.step,
                      "text-gray-500 group-hover:text-gray-700": !step.isCompleted
                    }
                  },
                  [_vm._v("Step " + _vm._s(index + 1))]
                ),
                _c("span", { staticClass: "text-sm font-medium" }, [
                  _vm._v(_vm._s(step.stepName))
                ])
              ]
            )
          ])
        }),
        0
      )
    ]),
    _c("div", { staticClass: "my-4" }, [
      _vm.currentStep.step === "facebook_business_manager"
        ? _c("div", { staticClass: "bg-white rounded-md p-4" }, [
            _c("div", { staticClass: "space-y-8 divide-y divide-gray-200" }, [
              _c("div", [
                _vm._m(0),
                _c(
                  "div",
                  {
                    staticClass:
                      "mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
                  },
                  [
                    _vm._m(1),
                    _c("div", { staticClass: "sm:col-span-3" }, [
                      _c("div", [
                        _c(
                          "label",
                          {
                            staticClass:
                              "block text-sm font-medium text-gray-700",
                            attrs: { for: "username" }
                          },
                          [_vm._v(" Facebook Business manager Id ")]
                        ),
                        _c(
                          "div",
                          { staticClass: "mt-1 flex rounded-md shadow-sm" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.facebookManagerId,
                                  expression: "form.facebookManagerId"
                                }
                              ],
                              staticClass:
                                "form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                              attrs: { autofocus: "" },
                              domProps: { value: _vm.form.facebookManagerId },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.form,
                                    "facebookManagerId",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "mt-4" }, [
                        _c(
                          "label",
                          {
                            staticClass:
                              "block text-sm font-medium text-gray-700",
                            attrs: { for: "username" }
                          },
                          [_vm._v(" Facebook Page URL ")]
                        ),
                        _c(
                          "div",
                          { staticClass: "mt-1 flex rounded-md shadow-sm" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.facebookPageUrl,
                                  expression: "form.facebookPageUrl"
                                }
                              ],
                              staticClass:
                                "form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                              domProps: { value: _vm.form.facebookPageUrl },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.form,
                                    "facebookPageUrl",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]
                        )
                      ])
                    ])
                  ]
                )
              ]),
              _c("div", { staticClass: "mt-8 border-t border-gray-200 pt-5" }, [
                _c("div", { staticClass: "flex justify-end" }, [
                  _c(
                    "span",
                    { staticClass: "ml-3 inline-flex rounded-md shadow-sm" },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out disabled:opacity-75",
                          attrs: {
                            disabled:
                              _vm.$v.form.facebookManagerId.$invalid ||
                              _vm.$v.form.facebookPageUrl.$invalid,
                            type: "submit"
                          },
                          on: {
                            click: function($event) {
                              return _vm.showNextStep()
                            }
                          }
                        },
                        [_vm._v(" Next ")]
                      )
                    ]
                  )
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm.currentStep.step === "phone_number"
        ? _c("div", { staticClass: "bg-white rounded-md p-4" }, [
            _c("div", { staticClass: "space-y-8 divide-y divide-gray-200" }, [
              _c("div", [
                _vm._m(2),
                _c(
                  "div",
                  {
                    staticClass:
                      "mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
                  },
                  [
                    _c("div", { staticClass: "sm:col-span-3" }, [
                      _c("div", [
                        _c(
                          "label",
                          {
                            staticClass:
                              "block text-sm font-medium text-gray-700",
                            attrs: { for: "username" }
                          },
                          [_vm._v(" Phone Number (with country code) ")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "mt-1 flex rounded-md shadow-sm flex-col"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.apiPhoneNumber,
                                  expression: "form.apiPhoneNumber"
                                }
                              ],
                              staticClass:
                                "form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                              attrs: { autofocus: "" },
                              domProps: { value: _vm.form.apiPhoneNumber },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.form,
                                    "apiPhoneNumber",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _c(
                              "p",
                              { staticClass: "mt-2 text-sm text-gray-500" },
                              [
                                _vm._v(
                                  " this number should not be connected to whatsapp business / whatsapp personal account. If it is already connected please delete the account. "
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ])
                  ]
                )
              ]),
              _c("div", { staticClass: "mt-8 border-t border-gray-200 pt-5" }, [
                _c("div", { staticClass: "flex justify-end" }, [
                  _c(
                    "span",
                    { staticClass: "ml-3 inline-flex rounded-md shadow-sm" },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out disabled:opacity-75",
                          attrs: {
                            type: "submit",
                            disabled: _vm.$v.form.apiPhoneNumber.$invalid
                          },
                          on: {
                            click: function($event) {
                              return _vm.showNextStep()
                            }
                          }
                        },
                        [_vm._v(" Next ")]
                      )
                    ]
                  )
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm.currentStep.step === "business_details"
        ? _c("div", { staticClass: "bg-white rounded-md p-4" }, [
            _c("div", { staticClass: "space-y-8 divide-y divide-gray-200" }, [
              _c("div", [
                _vm._m(3),
                _c(
                  "div",
                  {
                    staticClass:
                      "mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
                  },
                  [
                    _c("div", { staticClass: "sm:col-span-3" }, [
                      _c("div", [
                        _c(
                          "label",
                          {
                            staticClass:
                              "block text-sm font-medium text-gray-700",
                            attrs: { for: "username" }
                          },
                          [_vm._v(" Business name ")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "mt-1 flex rounded-md shadow-sm flex-col"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.businessName,
                                  expression: "form.businessName"
                                }
                              ],
                              staticClass:
                                "form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                              attrs: { autofocus: "" },
                              domProps: { value: _vm.form.businessName },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.form,
                                    "businessName",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _c(
                              "p",
                              { staticClass: "mt-2 text-sm text-gray-500" },
                              [
                                _vm._v(
                                  " This is the name you have registered in the Facebook business manager "
                                )
                              ]
                            )
                          ]
                        )
                      ]),
                      _c("div", [
                        _c(
                          "label",
                          {
                            staticClass:
                              "block text-sm font-medium text-gray-700",
                            attrs: { for: "username" }
                          },
                          [_vm._v(" Business Physical Address ")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "mt-1 flex rounded-md shadow-sm flex-col"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.businessAddress,
                                  expression: "form.businessAddress"
                                }
                              ],
                              staticClass:
                                "form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                              domProps: { value: _vm.form.businessAddress },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.form,
                                    "businessAddress",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]
                        )
                      ])
                    ])
                  ]
                )
              ]),
              _c("div", { staticClass: "mt-8 border-t border-gray-200 pt-5" }, [
                _c("div", { staticClass: "flex justify-end" }, [
                  _c(
                    "span",
                    { staticClass: "ml-3 inline-flex rounded-md shadow-sm" },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out disabled:opacity-75",
                          attrs: {
                            disabled:
                              _vm.$v.form.businessName.$invalid ||
                              _vm.$v.form.businessAddress.$invalid,
                            type: "submit"
                          },
                          on: {
                            click: function($event) {
                              return _vm.showNextStep()
                            }
                          }
                        },
                        [_vm._v(" Next ")]
                      )
                    ]
                  )
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm.currentStep.step === "contact_details"
        ? _c("div", { staticClass: "bg-white rounded-md p-4" }, [
            _c("div", { staticClass: "space-y-8 divide-y divide-gray-200" }, [
              _c("div", [
                _vm._m(4),
                _c(
                  "div",
                  {
                    staticClass:
                      "mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
                  },
                  [
                    _c("div", { staticClass: "sm:col-span-3" }, [
                      _c("div", [
                        _c(
                          "label",
                          {
                            staticClass:
                              "block text-sm font-medium text-gray-700",
                            attrs: { for: "username" }
                          },
                          [
                            _vm._v(
                              " Your Whatsapp Phone Number (with country code) "
                            )
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "mt-1 flex rounded-md shadow-sm flex-col"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.contactPhoneNumber,
                                  expression: "form.contactPhoneNumber"
                                }
                              ],
                              staticClass:
                                "form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                              attrs: { autofocus: "" },
                              domProps: { value: _vm.form.contactPhoneNumber },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.form,
                                    "contactPhoneNumber",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]
                        )
                      ])
                    ])
                  ]
                )
              ]),
              _c("div", { staticClass: "mt-8 border-t border-gray-200 pt-5" }, [
                _c("div", { staticClass: "flex justify-end" }, [
                  _c(
                    "span",
                    { staticClass: "ml-3 inline-flex rounded-md shadow-sm" },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out disabled:opacity-75",
                          attrs: {
                            disabled: _vm.$v.form.$invalid,
                            type: "submit"
                          },
                          on: {
                            click: function($event) {
                              return _vm.submit()
                            }
                          }
                        },
                        [_vm._v(" Submit ")]
                      )
                    ]
                  )
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm.currentStep.step === "processing_application"
        ? _c("div", { staticClass: "bg-white rounded-md p-4" }, [
            _c("div", { staticClass: "flex items-center" }, [
              _c(
                "svg",
                {
                  staticClass: "h-6 w-6 text-green-400",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    }
                  })
                ]
              ),
              _c("h2", { staticClass: "text-xl text-cool-gray-700 pl-4" }, [
                _vm._v(
                  " Your application is submitted and its getting processed. "
                )
              ])
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h3", { staticClass: "text-lg leading-6 font-medium text-gray-900" }, [
        _vm._v(" Facebook Business Manager ID ")
      ]),
      _c("p", { staticClass: "mt-1 text-sm text-gray-500" }, [
        _vm._v(" Don't know what is FB manager Id is? "),
        _c(
          "a",
          {
            staticClass: "text-blue-500",
            attrs: {
              href:
                "https://en-gb.facebook.com/business/help/1181250022022158?id=180505742745347",
              target: "_blank"
            }
          },
          [_vm._v("Click here ")]
        ),
        _vm._v(". ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sm:col-span-3" }, [
      _c("img", {
        staticClass: "rounded-md p-4",
        attrs: { src: require("../../assets/fbm.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h3", { staticClass: "text-lg leading-6 font-medium text-gray-900" }, [
        _vm._v(" Phone Number ")
      ]),
      _c("p", { staticClass: "mt-1 text-sm text-gray-500" }, [
        _vm._v(
          " This is the number you want to set up as your official WhatsApp number. "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h3", { staticClass: "text-lg leading-6 font-medium text-gray-900" }, [
        _vm._v(" Business Details ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h3", { staticClass: "text-lg leading-6 font-medium text-gray-900" }, [
        _vm._v(" Contact details ")
      ]),
      _c("p", { staticClass: "mt-1 text-sm text-gray-500" }, [
        _vm._v(
          " If we need any detail from your side regarding the whatsapp application we will use this number to contact you. "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }